module.exports = __webpack_public_path__ + "static/img/14003012.b934285b.png";